import { Component } from '@angular/core';
import { TextInputComponent } from '../text-input/text-input.component';

@Component({
  selector: 'app-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.scss'],
  standalone: false
})
export class OtpInputComponent extends TextInputComponent {
  constructor() {
    super();
    this.type = 'text';
    this.placeholder = '000000';
  }
}
